import React from 'react';
import { List, TextInput, BooleanInput, Filter } from 'react-admin';

import OutputCenterDataGrid from './OutputCenterDataGrid';

const OutputCenterFilter = (props) => (
	<Filter {...props}>
		<TextInput source="name" alwaysOn />
		<BooleanInput source="active" alwaysOn />
	</Filter>
);

const OutputCenterList = (props) => (
	<List
		filters={<OutputCenterFilter />}
		filterDefaultValues={{ active: true }}
		sort={{ field: 'createdAt', order: 'DESC' }}
		bulkActionButtons={false}
		{...props}
	>
		<OutputCenterDataGrid />
	</List>
);

export default OutputCenterList;
